<template>
  <a-tabs v-model:activeKey="activeKey" style="height: 100%">
    <a-tab-pane key="1" tab="学员轨迹">
      <div class="container" v-if="activeKey == '1'">
        <div class="tab-box">
          <div class="left">
            <a-radio-group
              v-model="tabType"
              @change="onChange"
              default-value="0"
              button-style="solid">
              <a-radio-button value="0"> 学员轨迹 </a-radio-button>
              <a-radio-button value="1"> 留言记录 </a-radio-button>
            </a-radio-group>
          </div>
          <a-button
            class="right"
            :style="{ color: activeType != 0 ? '#1890ff' : '#000000a6' }"
            @click="showModal"
            v-if="tabType == 0"
            ><a-icon type="filter" />{{ getActiveTypeLabel }}</a-button
          >
          <a-button type="link" class="rightTxt" @click="handleRefresh"
            >刷新</a-button
          >
          <a-modal
            v-model="visible"
            title="选择活跃类型"
            cancelText="取消"
            okText="确定"
            @ok="handleOk"
            @cancel="handleCancel">
            <a-radio-group
              class="radio-btn"
              v-model="activeType"
              v-for="(item, index) in filterList"
              :key="item.value">
              <a-radio-button :value="item.value">
                {{ item.label }}
              </a-radio-button>
            </a-radio-group>
          </a-modal>
        </div>
        <a-spin :spinning="loading">
          <div
            class="card-timeline scrollable-content"
            :style="{ marginLeft: tabType == 0 ? '0' : '-8px' }">
            <template v-if="tabType == 0">
              <a-timeline :reverse="true">
                <template v-for="(item, index) in activeTrajectoryList">
                  <a-timeline-item
                    :class="{
                      first: index === activeTrajectoryList.length - 1,
                    }"
                    :key="`timeline_${index}`">
                    <div class="column-timeline">
                      <div class="title">{{ item.activeBehaviorText }}</div>
                      <div
                        class="column-timeline-row"
                        v-for="(valItem, valIndex) in JSON.parse(
                          item.jsonValue
                        )"
                        :key="valIndex">
                        <div>
                          <span style="white-space: nowrap; margin-right: 10px"
                            >{{ valItem.name }}:</span
                          >
                          <span style="word-break: break-all">{{
                            valItem.name == "观看时长"
                              ? getDuration(valItem.value)
                              : valItem.value || "-"
                          }}</span>
                          <!-- <span :class="{'text-copy':valItem.isClipboard}" style="word-break: break-all;" @click="handleCopy(item.id,valItem)"><a-icon type="copy" v-if="valItem.isClipboard"/>{{ valItem.value }}</span> -->
                        </div>
                      </div>
                      <div class="time">{{ item.activeTime }}</div>
                    </div>
                  </a-timeline-item>
                </template>
              </a-timeline>
            </template>
            <template v-if="tabType == 1">
              <CardMessageRecord
                :customerId="externalUserId"
                ref="cardMessageRecord" />
            </template>
          </div>
        </a-spin>
        <!-- 加载中 -->
        <div class="loadingMask" v-if="isShowLoading">
          <a-spin tip="请稍等……" />
        </div></div
    ></a-tab-pane>
    <a-tab-pane key="2" tab="营销轨迹">
      <div style="margin-top: 35%">
        <a-empty description="暂无数据" />
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { queryListOfWeChat, queryValueByIdAndCode } from "@/api/active";
import CardMessageRecord from "./CardMessageRecord.vue";
import { envjudge, getRSAData } from "@/utils/index";
import { getCurExternalContact } from "@/utils/wxCodeAuth";
import { checkIfBindCustomer } from "@/api/auth";
import { checkMixin } from "@/mixins/checkMixin";
import store from "@/store";
import moment from "moment";

export default {
  name: "marketingDynamics",
  mixins: [checkMixin],
  components: {
    CardMessageRecord,
  },
  data() {
    return {
      visible: false,
      isShowLoading: false,
      loading: false,
      tabType: "0",
      isNull: false,
      filterList: [
        { value: "0", label: "全部" },
        { value: "1", label: "推广" },
        { value: "2", label: "企微" },
        { value: "3", label: "公开课" },
        { value: "4", label: "订单" },
        { value: "5", label: "其它" },
        { value: "6", label: "营销" },
      ],
      activeTrajectoryList: [],
      activeType: "0",
      externalUserId:
        process.env.VUE_APP_WEB_ENV === "dev"
          ? "wm9qetRQAAhIjAP9l8SuAqoMWsBMmmVw"
          : "",
      activeKey: "1",
    };
  },
  computed: {
    getActiveTypeLabel() {
      const selectedType = this.filterList.find(
        (item) => item.value === this.activeType && item.value !== "0"
      );
      return selectedType ? selectedType.label : "活跃类型";
    },
  },
  async created() {
    this.isShowLoading = true;
    this.loading = true;

    // 设置vuex信息，放APP.vue无效
    console.log("location.href", location.href);
    console.log("this.$route.query", this.$route.query);
    if (this.$route.query.corpId)
      store.commit("SET_CORPID", this.$route.query.corpId);
    if (this.$route.query.agentId)
      store.commit("SET_AGENTID", this.$route.query.agentId);
    if (this.$route.params.configId)
      store.commit("SET_CONFIGID", this.$route.params.configId);
    if (this.$route.query.tenantId)
      store.commit("SET_TENANTID", this.$route.query.tenantId);
    console.log(
      "设置企微信息：",
      "corpId:",
      store.getters.corpId,
      "agentId:",
      store.getters.agentId,
      "configId:",
      store.getters.configId
    );

    // 企微环境下检测和交互
    if (envjudge() === "com-wx-mobile" || envjudge() === "com-wx-pc") {
      console.log("检测未登录或授权111");
      // 检测未登录或授权
      this.checkLogin();
      // 检查是否已绑定crm账号
      this.checkIsBind();
      this.isShowLoading = false;
    } else {
      console.log("未登录或授权222");
      //用于开发测试
      this.queryListOfWeChat();
      this.isShowLoading = false;
    }
  },
  methods: {
    getRSAData,
    showModal() {
      this.visible = true;
    },
    onChange() {
      // if(this.tabType == '1') {
      //     this.$router.push(`/sendCardLink/?corpId=${this.$route.query.corpId}&agentId=${this.$route.query.agentId}`)
      // }
    },
    handleOk() {
      this.visible = false;
      this.queryListOfWeChat();
    },
    handleCancel() {
      this.activeType = "0";
    },
    checkLogin() {
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo || "" + userInfo === "undefined") {
        userInfo = JSON.parse(userInfo);
        console.log("未登录，path:", this.$route.path);
        this.$router.replace(
          `/login/${this.$route.query.corpId || store.getters.corpId}/${
            this.$route.query.agentId || store.getters.agentId
          }?redirect=${decodeURIComponent(this.$route.path)}`
        );
      } else {
        this.checkIsBind();
      }
    },
    async checkIsBind() {
      if (!this.externalUserId) {
        this.externalUserId = await getCurExternalContact();
      }
      try {
        const res = await checkIfBindCustomer({
          externalUserId: this.externalUserId,
          corpId: store.getters.corpId,
          tenantId: store.getters.tenantId,
        });
        if (res.result === 1) {
          this.queryListOfWeChat();
        } else {
          this.isNull = true;
        }
      } catch (error) {
        console.error("Error while checking bind status:", error);
      } finally {
        this.loading = false;
      }
    },
    async queryListOfWeChat() {
      this.loading = true;
      let userInfo = localStorage.getItem("userInfo");
      if (userInfo) userInfo = JSON.parse(userInfo);
      try {
        if (!this.externalUserId) {
          this.externalUserId = await getCurExternalContact();
        }

        const { result } = await queryListOfWeChat({
          activeType: this.activeType,
          corpId: store.getters.corpId,
          externalUserId: this.externalUserId,
          weChatUserId: userInfo.userId,
        });
        this.isNull = result.length === 0 ? true : false;
        this.activeTrajectoryList = result;
      } catch (error) {
        console.error("queryListOfWeChat require failed:", error);
      } finally {
        this.loading = false;
      }
    },
    // 得到时长
    getDuration(duration) {
      if (duration) {
        const time = moment.duration(duration, "seconds");
        const hours = Math.floor(time.asHours());
        const minutes = time.minutes();
        const seconds = time.seconds();
        return `${hours < 10 ? `0${hours}` : hours}:${
          minutes < 10 ? `0${minutes}` : minutes
        }:${seconds < 10 ? `0${seconds}` : seconds}`;
      }
    },
    // 刷新
    handleRefresh() {
      this.tabType == 0
        ? this.queryListOfWeChat()
        : this.$refs.cardMessageRecord.getMessageRecord();
    },
    //复制字段
    // async handleCopy(id, item) {
    //     if (!item.isClipboard) return;
    //     try {
    //         let options = {
    //             fieldCode: item.fieldCode,
    //             id: id
    //         };
    //         let res = await queryValueByIdAndCode(options);
    //         // 解密字段值
    //         let value = getRSAData(res.result.fieldValue);
    //         setTimeout(() => {
    //             // 创建 input 元素并设置复制内容
    //             const input = document.createElement('input');
    //             document.body.appendChild(input);
    //             input.setAttribute('value', value);
    //             input.select();
    //             input.setSelectionRange(0, input.value.length);
    //             if (document.execCommand('copy')) {
    //                 document.execCommand('copy');
    //                 this.$message.success("复制成功，请前往粘贴！");
    //             } else {
    //                 this.$message.error("复制失败");
    //             }
    //             document.body.removeChild(input);
    //         }, 200);
    //     } catch (error) {
    //         console.error("查询失败", error);
    //     }
    // },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding-left: 20px;
  padding-right: 5px;
  padding-top: 10px;
}
.tab-box {
  display: flex;
  align-items: center;
  .left {
    flex: 3;
    /deep/.ant-radio-group {
      width: 100%;
      font-size: 12px;
      display: inline-flex;
      flex-wrap: nowrap;
      overflow: hidden;
      .ant-radio-button-wrapper {
        // width:50%;
        text-align: center;
      }
      .ant-radio-button-wrapper:first-child {
        border-radius: 15px 0 0 15px;
      }
      .ant-radio-button-wrapper:last-child {
        border-radius: 0 15px 15px 0;
      }
    }
  }
  .right {
    flex: 1;
    padding-left: 15px;
    border: none;
    font-size: 12px;
  }
  .rightTxt {
    font-size: 12px;
  }
}

/deep/.ant-modal {
  max-width: calc(100vw - 50px);
  .ant-modal-header {
    padding-left: 18px;
  }
  .ant-modal-body {
    padding: 24px 0 24px 10px;
  }
  .ant-modal-footer {
    text-align: center;
    border-top: none;
  }
}
.radio-btn {
  /deep/ .ant-radio-button-wrapper {
    font-size: 12px;
    width: 82px;
    text-align: center;
    margin-bottom: 10px;
    margin-left: 8px;
    border-radius: 15px;
    border: 1px solid #d9d9d9;
  }
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):first-child {
    border-color: #1890ff;
  }
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):hover {
    color: #40a9ff;
    border-color: #40a9ff;
  }
  .ant-radio-button-wrapper::before {
    display: none;
  }
}
/deep/ .ant-timeline-item-tail {
  border-left: 2px solid #1890ff;
}
/deep/ .first {
  .ant-timeline-item-head-blue {
    background-color: #1890ff;
  }
}
.card-timeline {
  margin-top: 12px;
  padding-top: 12px;
  //   height: 100%;
  //   overflow: auto;
}
.scrollable-content {
  height: calc(100vh - 130px); /* 计算剩余高度，150px 为上面两个盒子的总高度 */
  overflow-y: auto; /* 允许垂直滚动 */
}
.column-timeline {
  // background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  // padding: 4px 16px 4px 8px;
  padding: 0 4px;

  .title {
    font-size: 15px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 5px;
    align-self: start;
  }
  .column-timeline-row {
    display: flex;
    flex: 1;
    line-height: 20px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 4px;
  }
  .time {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
  }
  .text-copy {
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
